import moment from 'moment'
import { rutWithDash } from '../../../../../utils/formatter'
import { parseFilterAmount } from '../../../../../utils/amountInput'

const MAX_TEXT_SIZE = 50
const MAX_DOCNUM_SIZE = 500

export const parseFilterInput = (name, value) => {
  if (['rut'].includes(name)) return value
  if (['amountStart', 'amountEnd'].includes(name)) return parseFilterAmount(value)
  if (['isPaid', 'notPaid', 'inform', 'hasInnerComments', 'isReported'].includes(name)) {
    if (value === 'true' || value === true) return true
    if (value === 'false' || value === false) return false
  }
  if (['dateStart', 'dateEnd'].includes(name)) {
    if (value) {
      const parsed = moment.utc(value, ['YYYY-MM-DD', moment.ISO_8601], true)
      return parsed.isValid() ? parsed.toISOString() : value
    }
  }
  if (['name'].includes(name)) {
    if (value) return value.substring(0, MAX_TEXT_SIZE)
  }
  if (['docNum'].includes(name)) {
    if (value) return value.substring(0, MAX_DOCNUM_SIZE)
  }

  return value
}